import { Profile } from '@creditornot/cb-icons';
import React, { MouseEventHandler } from 'react';
import styled from 'styled-components';

export type Props = {
  className?: string;
  email?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  profilePicUrl?: string;
};

const Badge = styled.div`
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: block;
  background: rgb(255 255 255 / 5%);
  border: 1px solid rgb(255 255 255 / 15%);
  overflow: hidden;

  img {
    width: 100%;
  }
`;

const UserBadge = ({ className, email, profilePicUrl, onClick }: Props) => (
  <Badge className={className} onClick={onClick} key="UserBadge">
    {profilePicUrl ? <img src={profilePicUrl} alt={email} /> : <Profile />}
  </Badge>
);

export default UserBadge;
